import { HttpClient } from '@angular/common/http';
import { CompanyModel } from '../models/company.model';
import { AppService } from '../app.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CompanyService extends AppService<CompanyModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getAll(): Promise<CompanyModel[]> {
    const result = await this.getAllAsync(`Local/Cashless`);
    return <CompanyModel[]>result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/company.service.ts